/* eslint-disable jsx-a11y/anchor-has-content */
import * as React from 'react';
import * as I18n from 'i18n-js';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import { AppleAppStoreLink, GooglePlayStoreLink } from './shared/app_store_links';
import LocaleSwitcher from './locale_switcher';

interface IAppIconsProps {
  userLocale: string;
}

function AppIcons(props: IAppIconsProps) {
  return (
    <div className="site-subfooter__app-icons">
      <div className="site-subfooter__app-icon">
        <AppleAppStoreLink userLocale={props.userLocale} />
      </div>
      <div className="site-subfooter__app-icon">
        <GooglePlayStoreLink userLocale={props.userLocale} />
      </div>
    </div>
  );
}

function SocialIcons() {
  return (
    <div className="site-subfooter__social-icons">
      <a
        href="https://www.instagram.com/reverb/"
        className="site-subfooter__social-icon site-subfooter__social-icon--ig"
        target="_blank"
        rel="noopener noreferrer"
        title="Instagram"
        aria-label="Instagram"
      />
      <a
        href="https://www.facebook.com/reverbmarket"
        className="site-subfooter__social-icon site-subfooter__social-icon--fb"
        target="_blank"
        rel="noopener noreferrer"
        title="Facebook"
        aria-label="Facebook"
      />
      <a
        href="https://www.youtube.com/user/reverbmarket"
        className="site-subfooter__social-icon site-subfooter__social-icon--yt"
        target="_blank"
        rel="noopener noreferrer"
        title="Youtube"
        aria-label="Youtube"
      />
      <a
        href="https://www.pinterest.com/reverbmarket/"
        className="site-subfooter__social-icon site-subfooter__social-icon--pi"
        target="_blank"
        rel="noopener noreferrer"
        title="Pinterest"
        aria-label="Pinterest"
      />
    </div>
  );
}

function SiteSubFooter() {
  const { locale } = useUser();

  return (
    <div className="site-subfooter">
      <div className="site-wrapper">
        <div className="d-flex fx-align-center tablet-d-block">
          <div>
            <LocaleSwitcher />
          </div>
          <div className="site-subfooter__icon-messages">
            <div
              className="site-subfooter__icon-message site-subfooter__icon-message--gives"
            >
              <div>
                <h4>
                  {I18n.t('discovery.siteSubFooter.givesTitle')}
                </h4>
                <p>
                  {I18n.t('discovery.siteSubFooter.givesDescription')}
                </p>
              </div>
            </div>
            <div
              className="site-subfooter__icon-message site-subfooter__icon-message--carbon"
            >
              <div>
                <h4>
                  {I18n.t('discovery.siteSubFooter.carbonTitle')}
                </h4>
                <p>
                  {I18n.t('discovery.siteSubFooter.carbonDescription')}
                </p>
              </div>
            </div>
          </div>
          <div>
            <SocialIcons />
            <AppIcons userLocale={locale} />
          </div>
        </div>
      </div>
      <div className="site-wrapper size-90 mt-1 tablet-align-center">
        <ul>
          <li className="d-inline-block mr-1">
            {I18n.t('discovery.siteSubFooter.copyright')}
          </li>
          <li className="d-inline-block mr-1">
            <a href="/page/terms">
              {I18n.t('discovery.siteSubFooter.terms')}
            </a>
          </li>
          <li className="d-inline-block">
            <a href="/page/privacy">
              {I18n.t('discovery.siteSubFooter.privacy')}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SiteSubFooter;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/site_subfooter.tsx